import * as React from 'react';

import { Skeleton, useTheme, styled } from '@mui/material';
import Column from '../../../../components/Column';
import Row from '../../../../components/Row';

const PaddedBottomRow = styled(Row)(({ theme }) => ({
  paddingBottom: theme.spacing(1),
}));

const ProgressChartSkeleton: React.FC = () => {
  const theme = useTheme();

  return (
    <>
      {[...Array(7)].map((_ignored, k) => (
        <React.Fragment key={k}>
          <PaddedBottomRow centered hAlign="flex-start">
            <Column grow>
              <Skeleton data-testid="printed-alert-skeleton" variant="rectangular" width={140} height={18} style={{ marginBottom: theme.spacing(1) }} />
              <Skeleton variant="rectangular" height={18} width="100%" style={{ marginBottom: theme.spacing(1) }} />
            </Column>
          </PaddedBottomRow>
        </React.Fragment>
      ))}
    </>
  );
};
export default ProgressChartSkeleton;
